import template from './donations-progress.html';
import controller from './donations-progress.controller';
import './donations-progress.scss';

let donationsProgressComponent = {
  template,
  controller,
  controllerAs: 'vm'
};

controller.$inject = ['donationsService'];

export default donationsProgressComponent;



// WEBPACK FOOTER //
// ./client/app/components/donations-progress/donations-progress.component.js